import axios from "axios";

const url = 'https://br-ledenappv2.onrender.com';
// const url = 'https://brinkruiters-leden-app.herokuapp.com';
// const url = 'http://localhost:3001';


export const handleData = async(data) => {
    switch (data.method) {
        case 'GET': {
            try {
                const result = await axios.get(`${url}/${data.path}`);
                return result;
            } catch (error) {
                console.log(error);
            }
            break;
        }
        case 'POST': {
            try {
                const result = await axios.post(`${url}/${data.path}`, data.input);
                return result;
            } catch (error) {
                console.log(error);
            }
            break;
        }
        case 'PATCH': {
            try {
                const result = await axios.patch(`${url}/${data.path}`, data.input);
                return result;
            } catch (error) {
                console.log(error);
                
            }
            break;
        }
        case 'DELETE': {
            try {
                const result = await axios.delete(`${url}/${data.path}`);
                return result;
            } catch (error) {
                console.log(error);
            }
            break;
        }

        default:
            return [];
            
    }
}
